module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "sidebar-minimizer",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.sidebarMinimize();
        _vm.brandMinimize()
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-d7debe76!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/SidebarMinimizer.vue
// module id = UNlI
// module chunks = 4